import { GET_COMPANY } from './gql/company';
export const getCompanyQuery = (gqlInstance, id) => {
    return gqlInstance
        .getClient('graphqlClient')
        .query({
        query: GET_COMPANY,
        fetchPolicy: 'network-only',
        variables: {
            id,
        },
    })
        .then(response => response.data.company);
};
//# sourceMappingURL=company.queries.js.map